import {createSelector} from 'reselect';

const list = state => state.oits.list;
const selectedGuid = state => state.oits.selectedGuid;
const trainingPhases = state => state.oits.trainingPhases;
const userContext = state => state.common.userContext;
const forms = state => state.forms.list;
const myTrainingProgram = state => state.myTrainingProgram.oit;

const selectedOit = createSelector(
  [list, selectedGuid],
  (oits, oitGuid) => {
    const selected = !oits ? null : oits.find(oit => oit.guid === oitGuid);
    return !selected ? null : selected;
  },
);

const selectedTrainingPhase = createSelector(
  [trainingPhases, selectedGuid],
  (phases, phaseGuid) => {
    const selected = !phases
      ? null
      : phases.find(phase => phase.guid === phaseGuid);
    return !selected ? null : selected;
  },
);

const myAssignedOits = createSelector(
  [list, userContext],
  (oits, fto) => {
    if(oits) {
      return oits.filter(oit => {
        return oit.trainingPhases.find(tf => {
          return tf.fto && tf.fto.ftoGuid === fto.userGuid;
        })
      });

    } else {
      return null
    }
  }
);

const selectedOitAvailableReports = createSelector(
  [selectedOit, userContext, forms],
  (oit, userContext, forms) => {
    if (!oit || !forms) return [];
    let signFlow = oit.trainingTracker.trainingProgram.signFlow;

    return Object.keys(signFlow)
      .filter(report => !['dor', 'eop', 'cont', 'rrt'].includes(report))
      .filter(report => {
        return signFlow[report].submit && signFlow[report].submit.roles.includes(userContext.scope)
      })
      .map(formType => {
        return ({
          type: formType,
          name: forms.find(form => form.type === formType && form.status === 'current') && forms.find(form => form.type === formType).name || formType
        })
      })

  }
);


const isEopAvailable = createSelector(
  [selectedOit, userContext, forms],
  (oit, userContext, forms) => {
    if (!oit || !forms) return [];
    let signFlow = oit.trainingTracker.trainingProgram.signFlow;

    return !!Object.keys(signFlow)
      .filter(report => ['eop'].includes(report))
      .filter(report => {
        return signFlow[report].submit && signFlow[report].submit.roles.includes(userContext.scope)
      })[0]

  }
);


const isDorAvailable = createSelector(
  [selectedOit, userContext, forms],
  (oit, userContext, forms) => {
    if (!oit || !forms) return [];
    let signFlow = oit.trainingTracker.trainingProgram.signFlow;

    return !!Object.keys(signFlow)
      .filter(report => ['dor'].includes(report))
      .filter(report => {
        return signFlow[report].submit && signFlow[report].submit.roles.includes(userContext.scope)
      })[0]

  }
);


const isRrtAvailable = createSelector(
  [selectedOit, userContext, forms],
  (oit, userContext, forms) => {
    if (!oit || !forms) return [];
    let signFlow = oit.trainingTracker.trainingProgram.signFlow;

    return !!Object.keys(signFlow)
      .filter(report => ['rrt'].includes(report))
      .filter(report => {
        return signFlow[report].submit && signFlow[report].submit.roles.includes(userContext.scope)
      })[0]

  }
);

const selectedMyAvailableReports = createSelector(
  [myTrainingProgram, userContext, forms],
  (oit, userContext, forms) => {
    if (!oit || !forms) return [];
    let signFlow = oit.trainingTracker.trainingProgram.signFlow;

    return Object.keys(signFlow)
      .filter(report => !['wor', 'eop', 'cont', 'rrt'].includes(report))
      .filter(report => {
        return signFlow[report].submit && signFlow[report].submit.roles.includes(userContext.scope)
      })
      .map(formType => {
        return ({
          type: formType,
          name: forms.find(form => form.type === formType) && forms.find(form => form.type === formType).name || formType
        })
      })

  }
);

const getAvailableAdditionalReports = (oit, role) => {
  let signFlow = oit.trainingTracker.trainingProgram.signFlow;

  Object.keys(signFlow)
    .filter(report => !['wor', 'dor', 'eop'].includes(report))
    .filter(report => signFlow[report].submit.roles.include(role))

};

export default {
  selectedOit,
  selectedTrainingPhase,
  myAssignedOits,
  selectedOitAvailableReports,
  selectedMyAvailableReports,
  isEopAvailable,
  isDorAvailable,
  isRrtAvailable
};
